import {useContext} from 'react'
import {CustomLanding36252Context} from '../../reducer'
import Button from '@material-ui/core/Button'
import {Container} from './components/Container'
import {WarningText} from './components/WarningText'
import {t} from '../../i18n'

export const Warning = () => {
  const [state] = useContext(CustomLanding36252Context)

  return (
    <Container inverse={state.language === 'ar'}>
      <WarningText>{t[state.language].warning}</WarningText>
      <Button variant="contained" color="primary" style={{boxShadow: 'none'}}>
        {t[state.language].okay}
      </Button>
    </Container>
  )
}
